var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_1299","data-name":"Group 1299"},[React.createElement("rect",{"id":"Rectangle_4435","data-name":"Rectangle 4435","width":"24","height":"24","fill":"none","key":0}),React.createElement("rect",{"id":"Rectangle_4436","data-name":"Rectangle 4436","width":"24","height":"2","transform":"translate(4.223 2.807) rotate(45)","fill":"#fff","key":1}),React.createElement("rect",{"id":"Rectangle_4437","data-name":"Rectangle 4437","width":"24","height":"2","transform":"translate(2.809 19.777) rotate(-45)","fill":"#fff","key":2})]));
}

CloseIcon.defaultProps = {"id":"Component_156_3","data-name":"Component 156 – 3","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
